// extracted by mini-css-extract-plugin
export default {"titleWrapper":"tabHeadline_titleWrapper__pzKBR","spinnerWrapper":"tabHeadline_spinnerWrapper__OB+Oq","title":"tabHeadline_title__Z57sC"};